<div class="box">
  <div class="circle" *ngFor="let item of items" (click)="select(item)"
       [ngClass]="{'active': item.value == value || item.value == highlight, 'disabled': disabled, 'smaller': item.class === 'smaller'}">
    {{item.text | translate}}
      <app-inline-svg [file]="'assets/img/radio-active.svg'" *ngIf="!disabled && item.value == value"></app-inline-svg>
    <img src="assets/img/radio-disable.svg" alt="Manager" *ngIf="disabled && item.value == value || item.value != value && item.value == highlight">
  </div>
</div>
